/**
 * Adds parameters to the given URL based on the provided params object.
 *
 * @param {string} url - The URL to which parameters will be added
 * @param {Object} params - The parameters to be added to the URL
 * @return {string} The updated URL with the added parameters
 */
export default function addURLParameters(url, params) {
    if (!url.match(/\?/)) {
        url += '?';
    } else {
        url += '&';
    }
    let newParams = [];
    for (let p in params) {
        newParams.push(`${encodeURIComponent(p)}=${encodeURIComponent(params[p])}`);
    }
    return url + newParams.join('&');
}
